import React, { useState } from 'react';
import { Button, SaveButton, useCreate, useNotify, FormWithRedirect, useRefresh } from 'react-admin';
import { Grid } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import CloseIcon from '@material-ui/icons/Close';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import RichTextInput from 'ra-input-rich-text';
import CustomAddressInput from '../components/CustomAddressInput';
import CustomContactInput from '../components/CustomContactInput';
import CustomNameLocationInput from '../components/CustomNameLocationInput';
import ContactAdd from '../contacts/ContactAdd';
import ContactIcon from '@material-ui/icons/PermPhoneMsg';
import AddressIcon from '@material-ui/icons/Room';
import LocationsIcon from '@material-ui/icons/Apartment';

function LocationAdd({ record, onChange }) {
    const [showDialog, setShowDialog] = useState(false);
    const [create, { loading }] = useCreate('locations');
    const notify = useNotify();

    const [contact, setContact] = useState([]);

    const handleClick = () => { setShowDialog(true); setContact([]); };
    const handleCloseClick = () => { setShowDialog(false); setContact([]);};

    const handleSubmit = customer_id =>
        async values => {
            var {
                name,
                notes,
                address,
                contact
            } = values;

            create(
                {
                    payload: {
                        data: {
                            "customer_id": customer_id,
                            "name": name,
                            "status": "Active",
                            "notes": notes,
                            "address": {
                                "street": address.street,
                                "city": address.city,
                                "state": address.state,
                                "zip": address.zip,
                            },
                            "contact": {
                                "display_name": (contact != undefined || contact != null) ? contact.display_name : '',
                                "email": (contact != undefined || contact != null) ? contact.email : '',
                                "phone": (contact != undefined || contact != null) ? contact.phone : '',
                                "notes": (contact != undefined || contact != null) ? contact.notes : '',
                            }
                        }
                    }
                },
                {
                    onSuccess: () => {
                        setShowDialog(false);
                        onChange();
                        notify('Location created', 'info', {}, false);
                    },
                    onFailure: (error) => notify(`Error: ${error.message}`, 'warning'),
                }
            );
        };


    return (
        <>
            <Button className="btn btn-light btn-sm text-danger m-0 p-0 mb-1" style={{ fontSize: '0.80em' }} onClick={handleClick} label="Add">
                <AddIcon className="m-0" />
            </Button>
            <Dialog
                fullWidth
                maxWidth="md"
                open={showDialog}
                onClose={handleCloseClick}
                aria-label="Add location"
            >
                <DialogTitle>
                    <Grid container direction="row" justify="content-between" className="m-0 p-0">
                        <h4 className="p-0 text-danger mx-0" style={{ marginLeft: '-8px' }}><LocationsIcon style={{ fontSize: '32px' }} /> Add Location </h4>
                        <Grid item style={{ marginLeft: "auto" }}>
                            <CloseIcon item
                                onClick={handleCloseClick}
                                disabled={loading}
                                style={{ cursor: "pointer", color: "gray" }}
                            />
                        </Grid>
                    </Grid>
                </DialogTitle>

                <FormWithRedirect
                    resource="locations"
                    save={handleSubmit(record.id)}
                    render={({
                        handleSubmitWithRedirect,
                        pristine,
                        saving
                    }) => (
                        <div>
                            <DialogContent className="m-2 p-2 mb-0 pb-0">
                                <div style={{ overflow: 'hidden' }}>
                                    <div className="px-2">
                                        <CustomNameLocationInput />
                                    </div>

                                    <div className="row row-cols-1 px-2 py-0 m-0 mb-3">
                                        <div className="rounded" style={{ border: '1px solid', borderColor: 'rgb(211, 211, 211)' }}>
                                            <RichTextInput source="notes" label="Notes" stripTags emptyText="Notes" />
                                        </div>
                                    </div>

                                    <h6 className="font-weight-normal pt-2">{<AddressIcon className="d-inline text-danger" style={{ fontSize: '28px' }} />} Address ·</h6>
                                    <div className="px-2 mt-3 w-100">
                                        <CustomAddressInput record={{ record }} />
                                    </div>

                                    <div className="d-flex w-100 px-2 align-items-center">
                                        <h6 className="font-weight-normal pt-2">{<ContactIcon className="d-inline text-danger" style={{ fontSize: '28px' }} />} Contact</h6>
                                        <ContactAdd record={{ record }} onChange={onChange} contact={setContact} />
                                    </div>
                                    <div className="px-2 w-100">
                                        <CustomContactInput record={{ record }} contact={contact} />
                                    </div>
                                </div>
                            </DialogContent>

                            <DialogActions>
                                <div className="p-2 pb-3 d-flex justify-content-start w-100">
                                    <SaveButton
                                        className="mx-2"
                                        label="Add New Location"
                                        handleSubmitWithRedirect={
                                            handleSubmitWithRedirect
                                        }
                                        pristine={pristine}
                                        saving={saving}
                                        disabled={loading}
                                    />
                                </div>
                            </DialogActions>
                        </div>
                    )}
                />
            </Dialog>
        </>
    );
}

export default LocationAdd;
